import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

import Carousel from 'nuka-carousel';


//CORE COMPONENTS
import styled from 'styled-components';

//LAYOUT
import {
    Container,
    ContainerWrap,
    ContainerPadding,
} from '../../../components-core/packages/components-core/dist/container/index';
import { Layout } from '../../../components-core/packages/components-core/dist/layout/index'
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import { AspectRatioContainer, AspectRatio } from '../../../components-core/packages/components-core/dist/aspect-ratio-container/index';

//STYLE
import { Text, TextAppearance } from '../../../components-core/packages/components-core/dist/text';
import { Link } from '../../../components-core/packages/components-core/dist/link/index';
import { LazyImage } from '../../../components-core/packages/components-core/dist/image/index';

//ICONS CORE
import { ArrowRight } from '../../../components-core/packages/icons-core/dist/ArrowRight/index';

import { encodeHTMLEntities } from '../../helpers/encoders/Encoder';



const OpacityContainer = styled.div`
    opacity: ${props => props.opacity};
`;


const TextContainer = styled.div`
    width: 100%;
    padding: 0 0 20px 0;

    @media screen and (max-width: 560px) {
        margin-top: 20px;
    }
`;

class FastLinks extends React.Component {

    constructor() {
        super();
        this.state = {
            currentSlide: 0,
        }
    }

    renderImage(data, index) {
        const image = <LazyImage srcPlaceholder={data.photo} src={data.photo} alt={'volkswagen-arac'} />

        const isMobile = typeof window !== `undefined` && window.innerWidth <= 768;

        if(index==0 && isMobile){
            return (
                <Container stretchContent={true} padding={{ bottom: ContainerPadding.dynamic0100 }}>
                    <BreakpointWrapper max={Breakpoints.b560}>
                        <AspectRatioContainer ratio={AspectRatio['1:1']}>
                            {image}
                        </AspectRatioContainer>
                    </BreakpointWrapper>
                    <BreakpointWrapper min={Breakpoints.b560}>
                        {image}
                    </BreakpointWrapper>
                </Container>
                )
        }else if(index==1 && isMobile){
            return (
                <Container stretchContent={true} padding={{ bottom: ContainerPadding.dynamic0100 }}>
                    <BreakpointWrapper max={Breakpoints.b560}>
                        <AspectRatioContainer ratio={AspectRatio['2:3']}>
                            {image}
                        </AspectRatioContainer>
                    </BreakpointWrapper>
                    <BreakpointWrapper min={Breakpoints.b560}>
                        {image}
                    </BreakpointWrapper>
                </Container>
                )
        }else {
            return (
                <Container stretchContent={true} padding={{ bottom: ContainerPadding.dynamic0100 }}>
                    <BreakpointWrapper max={Breakpoints.b560}>
                        <AspectRatioContainer ratio={AspectRatio['1:1']}>
                            {image}
                        </AspectRatioContainer>
                    </BreakpointWrapper>
                    <BreakpointWrapper min={Breakpoints.b560}>
                        {image}
                    </BreakpointWrapper>
                </Container>
                )
        }


    }

    renderSection() {
        const currentSlide = this.state.currentSlide;
        const {
            custom,
            custom1,
            custom2,
            custom3,
            custom4,
            custom5,
            custom6,
            custom7,
            custom8,
            custom9,
            custom10,
            custom11
        } = this.props;

        const demoObjects = [
            {
                'photo': custom9,
                'title': encodeHTMLEntities(custom),
                'linkDescription': encodeHTMLEntities(custom3),
                'link': custom6
            },
            {
                'linkDescription': encodeHTMLEntities(custom4),
                'title': encodeHTMLEntities(custom1),
                'photo': custom10,
                'link': custom7
            },
         
        ]
      
        return demoObjects.map((data, index) =>
            <Container
                stretchContent={true}
                wrap={ContainerWrap.always}
                padding={mobileContainerPadding}
            >
                <OpacityContainer
                    opacity={typeof window !== 'undefined' && window.innerWidth > 560 ? 1 : index === currentSlide ? 1 : 0.4}
                >
                    {this.renderImage(data, index)}
                    <TextContainer>
                        <Container wrap={ContainerWrap.always} >
                            <Text appearance={TextAppearance.headline0300} bold >
                                {data.title}
                            </Text>
                            <Text appearance={TextAppearance.label0200} bold>
                                <Link isInline href={data.link} target={'_blank'} >
                                    {data.linkDescription} <ArrowRight variant={'small'} />
                                </Link>
                            </Text>
                        </Container>
                    </TextContainer>
                </OpacityContainer>
            </Container>

           
        )
    }

    renderLayout() {
        return (
            <Layout appearance={layoutBreakpoints} >
                {this.renderSection()}
            </Layout>
        )
    }

    renderSlider() {
        return (
            <Carousel
                slidesToShow={1.4}
                cellAlign={'left'}
                defaultControlsConfig={{ pagingDotsStyle: { fill: 'transparent' } }}
                renderCenterLeftControls={() => undefined}
                renderCenterRightControls={() => undefined}
                scrollMode={'page'}
                edgeEasing={'easeQuadIn'}
                renderBottomCenterControls={false}
                afterSlide={(slideIndex) => this.setState({ currentSlide: slideIndex })}
            >
                {this.renderSection()}
                

            </Carousel>
        )
    }
/* 
    
*/
    render() {
        return (
            <Container padding={{ bottom: ContainerPadding.dynamic0250 }} stretchContent={true}>
                <BreakpointWrapper min={Breakpoints.b560}>
                    {this.renderLayout()}
                </BreakpointWrapper>
                <BreakpointWrapper max={Breakpoints.b560}>
                    {this.renderSlider()}
                </BreakpointWrapper>
            </Container>
        )
    }
}


const defaultBreakpoints = [
    { name: '.', columns: 1 },
    { name: 'b', columns: 7 },
    { name: 'd', columns: 7 },
    { name: 'f', columns: 7 },
    { name: '.', columns: 2 },
]

const mobileBreakpoints = [
    { name: 'b', columns: 24 },
    { name: 'd', columns: 24 },
    { name: 'f', columns: 24 },
]

const layoutBreakpoints = {
    [Breakpoints.default]: mobileBreakpoints,
    [Breakpoints.b560]: defaultBreakpoints,
}

const mobileContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.grid001
    }
}


export default FastLinks;
